import { Routes } from '@angular/router';
import { ErrorComponent } from 'src/app/features/secure/error/error.component';
import { AuthGuardService } from 'src/app/services/authGuard/authGuard.service';

import { ContactSupportComponent } from 'src/app/features/secure/contact-support/contact-support.component';
import { DocumentSpecificationsComponent } from 'src/app/features/secure/document-specifications/document-specifications.component';
import { TestToolGuideComponent } from 'src/app/features/secure/test-tool-guide/test-tool-guide.component';
import { DefaultRouteService } from 'src/app/services/defaultRoute/default-route.service';
import { HomeComponent } from './../../features/secure/home/home.component';
import { routes as onboardingRoutes } from './../../features/secure/onboarding/onboarding-routing.module';
import { UserProfileContainerComponent } from './../../features/secure/userprofile/user-profile-container';

export const SECURE_ROUTES: Routes = [
  {
    path: 'default',
    canActivate: [DefaultRouteService],
    component: HomeComponent,
  },
  {
    path: 'home',
    data: { breadcrumb: 'BREADCRUMB.HOME' },
    component: HomeComponent,
  },
  {
    path: 'error',
    component: ErrorComponent,
    canActivate: [AuthGuardService],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'UserModule',
    children: [
      {
        path: '',
        redirectTo: 'userProfile',
        pathMatch: 'full',
      },
      {
        path: 'userProfile',
        data: { breadcrumb: 'BREADCRUMB.USER_PROFILE' },
        component: UserProfileContainerComponent,
      },
    ],
  },
  {
    path: 'ContactSupport',
    canActivate: [AuthGuardService],
    component: ContactSupportComponent,
  },
  {
    path: 'DocumentSpecification',
    canActivate: [AuthGuardService],
    component: DocumentSpecificationsComponent,
  },
  {
    path: 'TestToolGuide',
    canActivate: [AuthGuardService],
    component: TestToolGuideComponent,
  },
  {
    path: 'TestToolGuide',
    canActivate: [AuthGuardService],
    component: TestToolGuideComponent,
  },
  {
    path: 'TestToolGuide',
    canActivate: [AuthGuardService],
    component: TestToolGuideComponent,
  },
  {
    path: 'TestToolGuide',
    canActivate: [AuthGuardService],
    component: TestToolGuideComponent,
  },
  {
    path: 'TestingModule',
    loadChildren: () =>
      import('../../wrapper-modules/edi-testing-wrapper.module').then(
        (m) => m.TestingWrapperModule
      ),
  },
  {
    path: 'OnboardingModule',
    data: { breadcrumb: 'BREADCRUMB.ONBOARDING' },
    canActivate: [AuthGuardService],
    children: onboardingRoutes,
  },
  {
    path: 'AdministrationModule',
    loadChildren: () =>
      import('../../wrapper-modules/administration-wrapper.module').then(
        (m) => m.AdministrationWrapperModule
      ),
  },
];
